// Imports
import styled from "styled-components"

import { Variables, Mixins } from "fajny-react"

const Container = styled.div`
    background-color: ${Variables.Colors.White};
    box-shadow: ${Variables.Shadows.M};
    border-radius: ${Variables.Radiuses.M};
`

const Image = styled.img`
    height: 100px;
    object-fit: contain;
    width: 100%;
    padding: ${Variables.Spacers.S};
`

const Content = styled.div`
    padding: ${Variables.Spacers.S};
    ${Mixins.Flexbox({
        $align: "stretch",
        $justify: "flex-start",
        $gap: "xs",
        $direction: "column",
    })};
`

export { Container, Image, Content }
